import Vue from 'vue';
import * as appUtils from '@/util/appUtils';

export const SINGLE_SELECT = 'singleSelect';
export const MULTIPLE_SELECT = 'multipleSelect';
export const MULTIPLE_CHOICE = 'multipleChoice';
export const RAW = 'raw';
export const SIMPLE = 'simple';
export const COMPLEX = 'complex';
const INPUT_EVENT = 'input';
const SELECT_EVENT = 'select';
const CLEAR_EVENT = 'clear';
const UPDATE_FULL_DATA = 'update:fullData';

export default {
  props: {
    // 自定义校验函数，支持async
    validate: Function,
    /**
     * vxe-table的filter的参数
     */
    params: Object,
    value: {
      type: [Array, Object, String, Number],
      default() {
        return null;
      }
    },
    /**
     * 每行数据或者树节点的唯一标识
     */
    rowKey: {
      type: String,
      default: 'id'
    },
    /**
     * 搜索下拉框每函数显示名称或者树节点显示的名称
     */
    rowName: String,
    searchOptionType: {
      type: String,
      default: SINGLE_SELECT
    },
    /**
     * 是否追加选中结果，true，在以选中的结果后面继续添加，false,清空之前选中的结果
     */
    appendResult: {
      type: Boolean,
      default: false
    },
    /**
     * 工作模式，分为raw, simple和complex, 默认是complex
     * raw: 是原始模式，只能在单选的情况下使用，用户可以点击按钮或者按回车键选择，选择完成后还能修改输入框的值，或者直接手动输入而不选择
     * 通过v-model得到的是输入框的值， raw模式下，rowName属性无效
     * complex： 复杂模式，支持单选和多选，用户只能通过点击按钮或者按回车键（单选）来选择数据，但是在单选模式下手动修改输入是无效的，
     * 通过v-model得到的是选中数据的对象（单选）或者对象数组（多选）
     * simple: 简单模式，与complex类似，但是通过v-model得到的是rowKey对应的值（单选）或者对应的值的数组（多选）。如果在单选状态下，没有选中数据，
     * 父组件通过v-model获得的值就是输入框的值
     */
    mode: {
      type: String,
      default: COMPLEX
    },
    fromArray: {
      type: Function,
      default: appUtils.fromArrayToCommaDivideString
    },
    toArray: {
      type: Function,
      default: appUtils.fromCommaDivideStringToArray
    },
    /**
     * 完整数据，simple模式，value可能只是对象中的某个某个属性或者是
     * 属性的数组，因此需要通过传入fullData来获取完整的数据
     */
    fullData: {
      type: [Array, Object],
      default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    presetButtonConfig: Object,
    triggerSearch: Function,
    limit: {
      type: Number,
      default: 0
    },
    dialogSelectType: String,
    returnDataFn: Function
    /* ,
    isClearVal: { // 是否清空用户输入值
      type: Boolean,
      default: true
    } */
  },
  data() {
    return {
      state: '', // 输入框的值
      selectData: this.searchOptionType === SINGLE_SELECT ? null : [],
      dialogVisible: false
    };
  },
  created() {
    if (this.params) {
      const data = this.params.column.filters[0].data;
      if (this.mode === COMPLEX) {
        this.state = this.getStateValue(data);
        this.selectData = data;
      } else {
        this.selectData = this.params.column.filters[0].fullData;
        this.state = data;
      }
    }
  },
  methods: {
    search () {
      this.$refs.dialog.search();
    },
    returnData () {
      this.dialogSelectCallback(this.$refs.dialog.getRecords());
    },
    returnAllData () {
      this.dialogSelectCallback(this.$refs.dialog.getAllRecords());
    },
    async handleTriggerSearch(args) {
      const {flag, value, searchOptionType} = args;
      if (this.triggerSearch) {
        // 先调用presetConfig进行默认初始化，然后用户通过监听事件改变presetConfig的值
        this.handlePresetConfig(args);
        await this.triggerSearch(args);
        this.$forceUpdate();
        const promise = this.showDialog(flag, value);
        if (searchOptionType === 'multipleSelect') {
          promise.then(() => {
            this.$refs.searchOption.handleClearMultipleInputVal();
            this.$refs.searchOption.handleMultipleInputFocus();
          });
        }
        return;
      }
      this.clickIcon(args);
    },
    setSelectData(selectData) {
      this.selectData = selectData;
    },
    /**
     * 重置selectData
     */
    resetSelectData() {
      this.selectData = this.searchOptionType === SINGLE_SELECT ? null : [];
    },
    getPlaceholder() {
      return this.state && this.disabled ? null : (this.$attrs.placeholder ? this.$attrs.placeholder : '请输入内容');
    },
    handleInput(value) {
      // 简单模式下需要value发射出去让父组件及时更新
      if (this.mode === RAW) {
        this.$emit(INPUT_EVENT, value);
        if (appUtils.isEmpty(value)) {
          this.$emit(CLEAR_EVENT);
        }
        return;
      }
      if (!appUtils.isEmpty(value)) {
        return;
      }
      this.selectData = null;
      if (this.complexMode) {
        this.$emit(INPUT_EVENT, this.selectData);
        this.$emit(CLEAR_EVENT);
      } else {
        this.$emit(UPDATE_FULL_DATA, this.selectData);
        this.$emit(INPUT_EVENT, value);
        this.$emit(CLEAR_EVENT);
      }
    },
    getFullData() {
      return this.fullData || this.value;
    },
    getStateValue(value) {
      if (!value || this.searchOptionType !== SINGLE_SELECT) {
        return '';
      }
      if (this.complexMode) {
        return value[this.realRowName];
      }
      return value;
    },
    removeTag(args) {
      const {tag, index} = args;
      this.selectData.splice(index, 1);
      this.$emit(UPDATE_FULL_DATA, this.selectData);
      if (this.complexMode) {
        this.$emit(INPUT_EVENT, this.selectData);
        this.$emit('remove-tag', args);
        return;
      }
      this.$emit(INPUT_EVENT, this.fromArray({ source: this.selectData, rowKey: this.rowKey }));
      this.$emit('remove-tag', args);
    },
    // auto-complete选中的结果
    handleSelect(item) {
      this.state = item[this.realRowName];
      this.selectData = item;
      if (this.complexMode) {
        this.$emit(INPUT_EVENT, item);
        this.$emit(SELECT_EVENT, item);
      } else {
        this.$emit(INPUT_EVENT, this.state);
        this.$emit(SELECT_EVENT, this.state);
      }
      this.$emit(UPDATE_FULL_DATA, item);
      if (this.params) {
        this.$emit('filter-select', { value: this.state, item, params: this.params });
      }
    },
    handleFocus(event) {
      this.$emit('focus', { value: this.state, event });
      if (this.mode === RAW) {
        return;
      }
      if (!this.selectData) {
        return;
      }
      this.state = this.selectData[this.rowKey];
    },
    handleBlur(event) {
      this.$emit('blur', { value: this.state, event });
      // raw模式在handleInput中已经state的emit到父组件，这里无需处理
      if (this.mode === RAW) {
        return;
      }
      // 如果用户清空了输入就直接返回，清空v-model的逻辑已经在handleInput中实现，这里不需要处理
      if (appUtils.isEmpty(this.state)) {
        return;
      }
      // 处理输入框有值的情况
      // 但是没有选中数据的情况
      if (!this.isSelectData) {
        // complex模式清空输入, simple无需处理
        if (this.complexMode) {
          this.state = '';
        }
        return;
      }
      // complex和simple模式只需要恢复state即可
      this.state = this.selectData[this.realRowName];
    },
    dialogSelectCallback(data, callback) {
      if (this.dialogSelectCallbackBefore && !this.dialogSelectCallbackBefore(data)) {
        return false;
      }
      if (!Array.isArray(data) || data.length < 1) {
        this.$notify({
          message: '请选择数据',
          type: 'error'
        });
        return false;
      }
      if (this.searchOptionType === SINGLE_SELECT) {
        this.selectData = data[0];
        if (this.returnDataFn) {
          const restData = [...data];
          restData.shift();
          this.returnDataFn({data, restData});
        }
        this.$emit(UPDATE_FULL_DATA, this.selectData);
        if (this.mode === RAW) {
          this.state = data[0][this.rowKey];
          this.$emit(INPUT_EVENT, this.selectData[this.rowKey]);
          this.$emit(SELECT_EVENT, this.selectData[this.rowKey]);
        } else if (this.mode === SIMPLE) {
          this.state = data[0][this.realRowName];
          this.$emit(INPUT_EVENT, this.selectData[this.rowKey]);
          this.$emit(SELECT_EVENT, this.selectData[this.rowKey]);
        } else {
          this.state = data[0][this.realRowName];
          this.$emit(INPUT_EVENT, this.selectData);
          this.$emit(SELECT_EVENT, this.selectData);
        }
        if (this.params) {
          const filterData = this.complexMode ? this.selectData : this.selectData[this.rowKey];
          this.params.column.filters[0].data = filterData;
          this.params.$panel.changeOption(null, true, this.params.column.filters[0]);
          this.$emit('filter-select', { data: filterData, params: this.params });
        }
      } else {
        if (this.appendResult) {
          // 对比新选择的数据和已有的数据
          // 如果设置了rowKey，就根据rowKey来比较，如果没有设置rowKey就直接比较地址
          if (Array.isArray(this.selectData)) {
            const arr = [].concat(this.selectData);
            const rowKey = this.rowKey;
            for (const newItem of data) {
              let flag = false;
              for (const oldItem of this.selectData) {
                if (rowKey) {
                  if (newItem[rowKey] + '' === oldItem[rowKey] + '') {
                    flag = true;
                    break;
                  }
                } else {
                  if (newItem === oldItem) {
                    flag = true;
                    break;
                  }
                }
              }
              if (!flag) {
                arr.push(newItem);
              }
            }
            data = arr;
          }
        }
        if (this.limit && data.length > this.limit) {
          throw new RuleError('选择了' + data.length + '条记录，大于限制值' + this.limit + '条');
        }
        this.selectData = data;
        this.$emit(UPDATE_FULL_DATA, this.selectData);
        let value = this.fromArray({ source: this.selectData, rowKey: this.rowKey });
        if (this.mode === SIMPLE) {
          this.$emit(INPUT_EVENT, value);
          this.$emit(SELECT_EVENT, value);
        } else {
          value = this.selectData;
          this.$emit(INPUT_EVENT, this.selectData);
          this.$emit(SELECT_EVENT, this.selectData);
        }
        if (this.params) {
          this.params.column.filters[0].data = value;
          this.params.$panel.changeOption(null, true, this.params.column.filters[0]);
          this.$emit('filter-select', { data: value, params: this.params });
        }
      }
      this.dialogVisible = false;
      callback && callback(data);
      return true;
    },
    clickIcon(args) {
      const {flag, value, searchOptionType} = args;
      this.handlePresetConfig(args);
      this.$emit('click-icon', args);
      this.$forceUpdate();
      const promise = this.showDialog(flag, value);
      if (searchOptionType === 'multipleSelect') {
        promise.then(() => {
          this.$refs.searchOption.handleClearMultipleInputVal();
          this.$refs.searchOption.handleMultipleInputFocus();
        });
      }
    },
    handlePresetConfig({flag, value}) {
      const fieldCode = this.rowKey;
      const hasOwnProperty = Object.prototype.hasOwnProperty;
      if (flag) {
        // 如果是回车，$attrs没有设置preset-config/presetConfig,或者preset-config/presetConfig不是数组，就需要在$attrs上设置
        if (!((hasOwnProperty.call(this.$attrs, 'preset-config') && Array.isArray(this.$attrs['preset-config'])) || (hasOwnProperty.call(this.$attrs, 'presetConfig') && Array.isArray(this.$attrs.presetConfig)))) {
          // 这里要用presetConfig，如果用preset-config,在弹窗中再弹窗就会无法传递参数给第二个弹窗
          Vue.set(this.$attrs, 'presetConfig', [{fieldCode, fieldValue: value}]);
          return;
        }
        // 如果有preset-config/presetConfig，就要改里面的fieldCode对应的值
        this.setPresetConfigValue({attrsKey: 'preset-config', fieldCode, fieldValue: value});
        this.setPresetConfigValue({attrsKey: 'presetConfig', fieldCode, fieldValue: value});
      } else {
        // 如果是点击icon，需要将fieldValue置空
        this.setPresetConfigValue({attrsKey: 'preset-config', fieldCode, fieldValue: ''});
        this.setPresetConfigValue({attrsKey: 'presetConfig', fieldCode, fieldValue: ''});
      }
    },
    /**
     * 设置$attrs中attrsKey属性对应fieldCode的item的fieldValue
     * @param attrsKey
     * @param fieldCode
     * @param fieldValue
     */
    setPresetConfigValue({attrsKey, fieldCode, fieldValue}) {
      if (Object.prototype.hasOwnProperty.call(this.$attrs, attrsKey) && Array.isArray(this.$attrs[attrsKey])) {
        for (const item of this.$attrs[attrsKey]) {
          if (item.fieldCode === fieldCode) {
            item.fieldValue = fieldValue;
          }
        }
        this.$attrs[attrsKey] = [...this.$attrs[attrsKey]];
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        // complex模式需要处理selectData和state
        if (this.complexMode) {
          if (newVal === this.selectData) {
            if (!this.state) {
              this.state = this.getStateValue(newVal);
            }
            return;
          }
          this.selectData = newVal;
          if (this.searchOptionType === SINGLE_SELECT) {
            this.state = this.getStateValue(newVal);
          }
          return;
        }
        if (this.mode === RAW) {
          if (this.searchOptionType !== SINGLE_SELECT) {
            return;
          }
          if (this.state === newVal) {
            return;
          }
          this.state = newVal;
          return;
        }
        // 简单模式下，外部传入的是基础数据,需要根据selectData或者fullData来做转换
        this.state = newVal
        // 有selectData和fullData，且selectData和fullData相等，表示fullData是用户通过选择数据来更新的
        if (this.fullData && this.selectData && this.selectData === this.fullData) {
          return;
        }
        if (this.fullData) {
          this.selectData = this.fullData;
          // 区分单选和多选的情况
          if (this.searchOptionType === SINGLE_SELECT) {
            return;
          }
          this.state = this.fromArray({ source: this.fullData, rowKey: this.rowKey });
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    getDebounce() {
      if (this.$attrs.debounce === undefined || this.$attrs.debounce === null) {
        return -1;
      }
      return this.$attrs.debounce;
    },
    dynamicTags() {
      if (!Array.isArray(this.selectData) || this.searchOptionType === SINGLE_SELECT) {
        return [];
      }
      return this.selectData;
    },
    /**
     * 真正的rowName,用户没有传入rowName的情况下使用rowKey来表示
     * @return {*}
     */
    realRowName() {
      return this.rowName || this.rowKey;
    },
    complexMode() {
      return this.mode === COMPLEX;
    },
    /**
     * 是否有选中的数据
     * @return {boolean}
     */
    isSelectData() {
      return (Array.isArray(this.selectData) && this.selectData.length > 0) || this.selectData !== null;
    }
  }
};
